var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClockOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none",
    viewBox: "0 0 28 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7581A5",
    d: "m18.165 11.322-6.233 6.262-2.267-2.267a1.07 1.07 0 0 0-1.502 0 1.07 1.07 0 0 0 0 1.502l3.004 3.003c.41.41 1.09.41 1.501 0l6.999-6.998a1.07 1.07 0 0 0 0-1.502 1.07 1.07 0 0 0-1.502 0Zm8.84-7.225L22.642.47a1.418 1.418 0 0 0-1.998.185c-.496.595-.41 1.487.184 1.997l4.35 3.627a1.418 1.418 0 0 0 1.997-.184 1.417 1.417 0 0 0-.17-1.998ZM2.808 6.279l4.35-3.627c.609-.51.694-1.402.184-1.997A1.4 1.4 0 0 0 5.358.47L.995 4.097a1.417 1.417 0 0 0-.17 1.998 1.4 1.4 0 0 0 1.983.184ZM14 2.666c-7.04 0-12.75 5.71-12.75 12.75 0 7.041 5.71 12.75 12.75 12.75s12.75-5.709 12.75-12.75c0-7.04-5.71-12.75-12.75-12.75Zm0 22.667c-5.468 0-9.917-4.448-9.917-9.917C4.083 9.948 8.532 5.5 14 5.5s9.917 4.448 9.917 9.916-4.449 9.917-9.917 9.917Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockOutlined);
export default __webpack_public_path__ + "static/media/icon-clock-outlined.adae3648.svg";
export { ForwardRef as ReactComponent };